import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Base_URL } from "../url";
import axios from "axios";
import { toast } from "react-toastify";

const EditBatches = () => {
  const [form, setForm] = useState({
    batchId: "",
    expDate: "",
    mfgDate: "",
    mrpIncGst: "",
    ptrExclGst: ""
  });

  const { batchId } = useParams();

  useEffect(() => {
    fetchBatch();
  }, [batchId]);

  const fetchBatch = async () => {
    try {
      const response = await axios.get(
        `${Base_URL}/BatchMaster/GetBatchFromBatchId/${batchId}`
      );

      const data = response.data;
     const formatDate = (d) => d ? d.split("T")[0] : "";

setForm({
  batchId: data.batch.batchId || "",
  expDate: formatDate(data.batch.expiryDate),
  mfgDate: formatDate(data.batch.mfgDate),
  mrpIncGst: data.label.mrpInclGst || "",
  ptrExclGst: data.label.ptrExclGst || ""
});

    } catch (error) {
      console.error("Error fetching batch:", error);
    }
  };

  const handleChange = (key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      batchId: form.batchId,
      mfgDate: new Date(form.mfgDate).toISOString(),
      expDate: new Date(form.expDate).toISOString(),
      mrpIncGst: parseFloat(form.mrpIncGst),
      ptrExclGst: parseFloat(form.ptrExclGst)
    };

    console.log("Sending Payload:", payload);

    try {
      const res = await axios.put(`${Base_URL}/BatchMaster/UpdateBatchById`, payload);

      if (res.status === 200) toast.success("Batch updated successfully!");
      else toast.error("Failed to update batch.");
    } catch (error) {
      toast.error("Server error!");
      console.error(error);
    }
  };

  const styles = {
    label: { fontSize: 14, fontWeight: 600, marginBottom: 6, color: "#212529" },
    control: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #ced4da",
      borderRadius: 4,
      boxSizing: "border-box"
    },
    group: { marginBottom: 16 }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-6">
        <Col>
          <Form.Group style={styles.group}>
            <Form.Label style={styles.label}>Batch Id</Form.Label>
            <Form.Control
              style={styles.control}
              type="text"
              value={form.batchId}
              disabled
            />
          </Form.Group>

          <Form.Group style={styles.group}>
            <Form.Label style={styles.label}>Expiry Date</Form.Label>
            <Form.Control
              style={styles.control}
              type="date"
              value={form.expDate}
              onChange={handleChange("expDate")}
            />
          </Form.Group>

          <Form.Group style={styles.group}>
            <Form.Label style={styles.label}>Manufacturing Date</Form.Label>
            <Form.Control
              style={styles.control}
              type="date"
              value={form.mfgDate}
              onChange={handleChange("mfgDate")}
            />
          </Form.Group>

          <Form.Group style={styles.group}>
            <Form.Label style={styles.label}>MRP (Inc GST)</Form.Label>
            <Form.Control
              style={styles.control}
              type="number"
              step="0.01"
              value={form.mrpIncGst}
              onChange={handleChange("mrpIncGst")}
            />
          </Form.Group>

          <Form.Group style={styles.group}>
            <Form.Label style={styles.label}>PTR (Excl GST)</Form.Label>
            <Form.Control
              style={styles.control}
              type="number"
              step="0.01"
              value={form.ptrExclGst}
              onChange={handleChange("ptrExclGst")}
            />
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            style={{ marginTop: 10, padding: "10px 20px", fontWeight: 600 }}
          >
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default EditBatches;
